import Link from 'next/link';

import { Button, Container, Text } from '@/atoms';
import { ButtonSize, ButtonVariant } from '@/atoms/button/types';

import { routes } from '@/lib';

import type { FunctionComponent } from 'react';
import type { TypeBannerErrorProps } from './types';

/**
 * BannerError
 */
export const BannerError: FunctionComponent<TypeBannerErrorProps> = ({
  className = '',
  overlay,
  backgroundImage,
  title,
  description,
  showReloadButton = false,
}: TypeBannerErrorProps) => (
  <Container
    classNameWrapper="w-full min-h-[350px] lg:min-h-[640px] flex flex-col justify-center items-center"
    className={className}
    backgroundImage={backgroundImage}
    wrapper
    overlay={overlay}
    align="center"
  >
    <div className="flex flex-col items-center text-center xs:max-w-[490px]">
      <Text className="text-headline text-headline--h2 mb-2 text-neutrals-0">
        {title}
      </Text>

      <Text className="text-body text-body--l mb-6 text-neutrals-0">
        {description}
      </Text>

      <div className="flex flex-col gap-6 md:flex-row">
        <Link href={routes.index} prefetch={false}>
          <Button
            as="span"
            size={ButtonSize.MEDIUM}
            variant={ButtonVariant.ELEVATED}
          >
            Ir a inicio
          </Button>
        </Link>

        {showReloadButton && (
          <Button
            outline
            size={ButtonSize.MEDIUM}
            variant={ButtonVariant.ELEVATED}
            onClick={() => location.reload()}
          >
            Volver a cargar
          </Button>
        )}
      </div>
    </div>
  </Container>
);

BannerError.displayName = 'BannerError';
